<h2 mat-dialog-title>Edit Device</h2>
<mat-dialog-content class="flex flex-col gap-2">
    <mat-form-field class="w-full">
        <mat-label>ID</mat-label>
        <input matInput [value]="data.deviceId" disabled />
    </mat-form-field>
    <mat-form-field class="w-full">
        <mat-label>Name</mat-label>
        <input matInput [value]="data.name || ''" disabled />
    </mat-form-field>
    <mat-form-field class="w-full">
        <mat-label>Model</mat-label>
        <input matInput [value]="data.model || ''" disabled />
    </mat-form-field>
    <mat-form-field class="w-full">
        <mat-label>Note</mat-label>
        <textarea
            matInput
            [(ngModel)]="note"
            placeholder="Enter a note..."
            rows="6"
        ></textarea>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
